import { useQuery } from '@tanstack/react-query';
import { listProjects, ProviderErrorResponse } from '@apis/projects';
import { PROJECTS_LIST_KEY } from '@constants/queryKeys';

/**
 * The sites the user can open — what the top bar's project selector lists and
 * what a bare section route (`/dashboard`, `/monitor`, …) picks a site from.
 * One query, so both read the same cached list.
 */
export function useProjectsList() {
  return useQuery({
    queryKey: PROJECTS_LIST_KEY,
    queryFn: ({ signal }) => listProjects(signal),
    staleTime: 60_000,
    // ProviderErrorResponse is a terminal error (the user must reconnect),
    // not a transient network blip — short-circuit retries so the reconnect
    // path surfaces quickly.
    retry: (failureCount, err) => (err instanceof ProviderErrorResponse ? false : failureCount < 2),
  });
}
